import { HubConnection } from '@microsoft/signalr'
import { IRemuneracaoBackofficeMessage } from '@/types/interfaces/backoffice-remuneracao/backoffice-remuneracao-message'
import EventBus from '@/plugins/EventBus'
import * as signalR from '@microsoft/signalr'
import { IRemuneracaoChatMessage } from '@/types/interfaces/backoffice-remuneracao/remuneracao-chat-message.interface'

const env: any = window

class ChatRemuneracaoConnectionService {
  private connection?: HubConnection
  private connectionParams?: IRemuneracaoChatMessage
  private canTryReconnectOnCloseConnection = false
  private messageListeners: MessageEventFn[] = []

  async openConnection(params: IRemuneracaoChatMessage) {
    this.canTryReconnectOnCloseConnection = true
    this.connectionParams = params

    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(`${env.API_FINX_SIGNALR_CHAT_REMUNERACAO}`, {
        accessTokenFactory: () => this.accessToken,
      })
      .configureLogging(signalR.LogLevel.Information)
      .build()

    // Create event listners
    this.createListeners()

    try {
      await this.connection!.start()
    } catch (err) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Ocorreu um erro ao iniciar a comunicação com o cálculo da remuneração', icon: 'warning', color: '#C62828' })
    }

    try {
      await this.connection.invoke('EntrarNoChat', params)
      // eslint-disable-next-line
      console.log('entrar no chat', params)
    } catch (err) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Ocorreu um erro ao entrar no grupo do cálculo da remuneração', icon: 'warning', color: '#C62828' })
    }

    return this.connection
  }

  /**
   * Kill the current connection
   */
  async closeConnection(params: IRemuneracaoChatMessage) {
    this.canTryReconnectOnCloseConnection = false

    try {
      if (this.connection) {
        await this.connection.invoke('SairDoChat', params)
        await this.connection!.stop()
        // eslint-disable-next-line
        console.log('passa quando fecha', params)
      }
    } catch (err) {
      await this.connection!.stop()
      // eslint-disable-next-line
      console.warn(err)
    }

    this.connection = undefined
  }

  listenMessageEvent(data: MessageEventFn) {
    this.messageListeners.push(data)
  }

  private createListeners() {
    this.connection!.onclose(() => {
      if (this.canTryReconnectOnCloseConnection) {
        this.openConnection(this.connectionParams!)
      }
    })

    this.connection!.on('ReceberUsuarioEntrouNoChat', (data: any) => {
      console.log('ReceberUsuarioEntrouNoChat', data)
    })

    this.connection!.on('ReceberUsuarioSaiuDoChat', async (data: any) => {
      console.log('ReceberUsuarioSaiuDoChat', data)
    })

    this.connection!.on('ReceberMensagem', (data: any) => {
      EventBus.$emit('receberMensagemChatRemuneracao', data)
      console.log('ReceberMensagem', data)
    })
  }


  private get accessToken() {
    const localStorageData: string = localStorage.getItem(`oidc.user:${env.API_FINX_AUTH}:portal-client-2`)!
    const user: any = JSON.parse(localStorageData)
    return user.access_token
  }
}

type MessageEventFn = (data: IRemuneracaoBackofficeMessage) => void


// eslint-disable-next-line import/prefer-default-export
export const chatRemuneracaoConnectionService = new ChatRemuneracaoConnectionService()
